import React from 'react'
import { Radio, RadioGroup, FormControlLabel } from '@mui/material'
import { styled } from '@mui/system'

const CustomRadio = styled(Radio)(({ theme }) => ({
    color: 'hsl(var(--light-grey))', // Default color
    '&.Mui-checked': {
        color: 'hsl(var(--primary))' // Color when checked
    },
    '& .MuiSvgIcon-root': {
        fontSize: '1.25rem'
        // Customize icon size
    }
}))

export default function CalendarRadio ({ handleDateTypeChange, dateType }) {
    return (
        <RadioGroup value={dateType} onChange={(e) => handleDateTypeChange(e)} defaultValue={dateType} row>
            <FormControlLabel
                value={1}
                control={<CustomRadio />}
                label="Hard Target"
            />
            <FormControlLabel
                value={2}
                control={<CustomRadio />}
                label="Soft Target"
            />
        </RadioGroup>
    )
}
